import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/reset.css";
import "./global.css";
import "antd/dist/reset.css";
import { setupNavigation } from "./services/api";
import { router } from "./router/routes";

const root = createRoot(document.getElementById("root")!);

setupNavigation((to: string) => {
  router.navigate(to);
});

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
